import { React, useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../components/LoaderScreen";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { Autocomplete, Box, TextField, MenuItem, FormControl, InputLabel, Select } from "@mui/material";
import { Add, Save } from "@mui/icons-material";
import DeleteIcon from '@mui/icons-material/Delete';
import { SelectModelosModal } from "./SelectModelosModal";
import EditIcon from '@mui/icons-material/Edit';
import { EditarModelosModal } from "./EditarModelosModal";
import { ultimoDiaDelMes } from "../../../Helpers/FormatFecha";

// Ultimo dia del mes actual en formato yyyy-MM-dd (hora local).
const getUltimoDiaMes = () => ultimoDiaDelMes();

const formatoFechaParaInput = (fecha) => {
    if (!fecha) return "";
    const partes = fecha.split(" ")[0].split("/");
    const [mes, dia, anio] = partes;
    return `${anio}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
};

export const AgregarCotizacionScreen = () => {
    const history = useHistory();
    const { state } = useLocation();
    const [openModal, setOpenModal] = useState(false);
    const [openModalEditar, setOpenModalEditar] = useState(false);
    const [selectedDetalle, setSelectedDetalle] = useState(false);
    const [asesores, setAsesores] = useState();
    const [rol, setRol] = useState();
    const [clientes, setClientes] = useState();
    const [modelos, setModelos] = useState();
    const [modelosEsquema, setModelosEsquema] = useState();
    const [sucursales, setSucursales] = useState();
    const [esquemaSeleccionado, setEsquemaSeleccionado] = useState("0");
    const [esquema, setEsquema] = useState(null);
    const [descuento, setDescuento] = useState("");
    const [moneda, setMoneda] = useState("MXN");
    const [modelosTabla, setModelosTabla] = useState()

    const [infoCotizacion, setInfoCotizacion] = useState({
        idasesor: 0,
        idcliente: 0,
        razon_social: "",
        crm: "",
        sucursal: 0,
        asunto: "",
        tipo_pago: "CO",
        fase: "",
        vigencia: getUltimoDiaMes(),
        detalle: []
    });

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const handleOpenModal = () => {
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleOpenModalEditar = (indice) => {
        setSelectedDetalle(infoCotizacion.detalle.filter((_, index) => index === indice));
        setOpenModalEditar(true);
    };

    const handleCloseModalEditar = () => {
        setSelectedDetalle(null);
        setOpenModalEditar(false);
    };

    useEffect(() => {
        GetDatos();
    }, []);

    const GetDatos = async () => {
        try {
            const requests = [
                request.get(
                    `DDLVendedor/Listado`
                ),
                request.get(
                    `Cotizaciones/ClientesSearch`
                ),
                request.get(
                    `Cotizaciones/SucursalesDDL`
                ),
                request.get(
                    `ListadoModelos/ModelosCotizacion`
                ),
                request.get(
                    `Cotizaciones/GetRol`
                ),
                request.get(
                    `PromocionesDisponibles/GetEsquemasDDL`
                )
            ];

            const [result1, result2, result3, result4, result5, result6] = await Promise.all(requests);

            // console.log(result2)
            setAsesores(result1);
            setClientes(result2);
            setSucursales(result3);
            setModelos(result4);
            setRol(result5[0].rol);
            setEsquema(result6);
        } catch (error) {
            Swal.fire("Error", "Ocurrió un error al cargar los datos.", "error");
        }
    };

    useEffect(() => {
        if (Array.isArray(esquema) && esquemaSeleccionado) {
            const esquemaObj = esquema.find((es) => es.idpromocion === Number(esquemaSeleccionado));

            if (esquemaObj && esquemaObj.idpromocion > 0) {
                request
                    .get(`ListadoModelos/ModelosCotizacionenEsquema?idpromocion=${esquemaObj.idpromocion}`)
                    .then((result) => {
                        setModelosEsquema(result);
                        setLoader((prev) => ({ ...prev, mostrar: false }));
                    })
                    .catch((error) => {
                        console.error(error);
                        setLoader((prev) => ({ ...prev, mostrar: false }));
                    });
            } else {
                setModelosEsquema([]);
            }
        }
    }, [esquemaSeleccionado]);


    const handleAgregarModelo = (modeloSeleccionadoModal) => {
        // console.log(descuentoModal)

        if (!modeloSeleccionadoModal || !modeloSeleccionadoModal.modelo) return;
        // Guardar solo el idmodelo y descuento en infoCotizacion.detalle
        const nuevoDetalle = {
            idmodelo: modeloSeleccionadoModal.modelo.idmodelo,
            descuento: modeloSeleccionadoModal.descuento,
            moneda: modeloSeleccionadoModal.moneda,
            esquema_pago: modeloSeleccionadoModal.esquema_pago
        };

        setInfoCotizacion((prev) => ({
            ...prev,
            detalle: [...(prev.detalle || []), nuevoDetalle],
        }));

        const modeloCompleto = modelos.find(
            (m) => m.idmodelo === modeloSeleccionadoModal.modelo.idmodelo
        );

        if (modeloCompleto) {
            const modeloConDescuento = {
                ...modeloCompleto,
                descuento: modeloSeleccionadoModal.descuento,
                moneda: modeloSeleccionadoModal.moneda,
                precio_promocion: modeloSeleccionadoModal.precio_promocion,
                esquema: modeloSeleccionadoModal.esquema
            };

            setModelosTabla((prev) => [...(prev || []), modeloConDescuento]);
        }
    };

    const handleModificarModelo = (modeloSeleccionadoModal) => {
        if (!modeloSeleccionadoModal || !modeloSeleccionadoModal.modelo) return;

        const idmodelo = modeloSeleccionadoModal.modelo.idmodelo;

        setInfoCotizacion((prev) => ({
            ...prev,
            detalle: (prev.detalle || []).map((item) =>
                item.idmodelo === idmodelo
                    ? {
                        ...item,
                        descuento: modeloSeleccionadoModal.descuento,
                        moneda: modeloSeleccionadoModal.moneda,
                        esquema_pago: modeloSeleccionadoModal.esquema_pago
                    }
                    : item
            ),
        }));

        setModelosTabla((prev) =>
            (prev || []).map((item) =>
                item.idmodelo === idmodelo
                    ? {
                        ...item,
                        descuento: modeloSeleccionadoModal.descuento,
                        moneda: modeloSeleccionadoModal.moneda,
                        precio_promocion: modeloSeleccionadoModal.precio_promocion,
                        esquema: modeloSeleccionadoModal.esquema
                    }
                    : item
            )
        );
    };


    // console.log(modelosTabla)

    const handleEliminarModelo = (index) => {
        setInfoCotizacion((prev) => ({
            ...prev,
            detalle: prev.detalle.filter((_, i) => i !== index),
        }));

        setModelosTabla((prev) =>
            prev.filter((_, i) => i !== index)
        );
    };

    const handleChangeMoneda = (nuevaMoneda) => {
        setMoneda(nuevaMoneda);

        // Actualizar moneda en infoCotizacion.detalle
        setInfoCotizacion((prev) => ({
            ...prev,
            detalle: prev.detalle.map((item) => ({
                ...item,
                moneda: nuevaMoneda,
            })),
        }));

        // Actualizar moneda en modelosTabla
        setModelosTabla((prev) =>
            (prev || []).map((item) => ({
                ...item,
                moneda: nuevaMoneda,
            }))
        );
    };


    // console.log(esquema)
    const convertirJSON = (jsonString) => {
        try {
            const caracteristicas = JSON.parse(jsonString);
            return caracteristicas.map((c, i) => (
                <span key={i}>
                    • {c.descripcion}
                    <br />
                </span>
            ));
        } catch (err) {
            return <span>-</span>; // Por si el JSON no es válido
        }
    };

    const guardarCotizacion = () => {
        if (infoCotizacion.idcliente === "" || infoCotizacion.idcliente === null || infoCotizacion.idcliente === undefined) {
            Swal.fire({
                title: "COTIZACION",
                text: "Debe seleccionar un cliente",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }
        if (infoCotizacion.razon_social === "" || infoCotizacion.razon_social === null || infoCotizacion.razon_social === undefined) {
            Swal.fire({
                title: "COTIZACION",
                text: "Debe seleccionar un cliente",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }
        if (rol !== 'Asesor' && infoCotizacion.idasesor === 0 || infoCotizacion.idasesor === "" || infoCotizacion.idasesor === null || infoCotizacion.idasesor === undefined) {
            Swal.fire({
                title: "COTIZACION",
                text: "Debe seleccionar un asesor de venta",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }

        if (infoCotizacion.tipo_pago === "" || infoCotizacion.tipo_pago === null || infoCotizacion.tipo_pago === undefined || infoCotizacion.precioLista <= 0) {
            Swal.fire({
                title: "COTIZACION",
                text: "Debe seleccionar un tipo de pago",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }

        if (infoCotizacion.vigencia === "" || infoCotizacion.vigencia === null || infoCotizacion.vigencia === undefined || infoCotizacion.precioLista <= 0) {
            Swal.fire({
                title: "COTIZACION",
                text: "Debe seleccionar la vigencia de la cotizacion",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }

        if (!Array.isArray(infoCotizacion.detalle) || infoCotizacion.detalle.length === 0) {
            Swal.fire({
                title: "COTIZACION",
                text: "Debe ingresar al menos un modelo para cotizar",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }

        setLoader({ ...loader, mostrar: true });
        const post = {
            idcliente: infoCotizacion.idCliente,
            razon_social: infoCotizacion.razon_social,
            idasesor: infoCotizacion.idasesor,
            crm: infoCotizacion.crm,
            asunto: infoCotizacion.asunto,
            idsucursal: infoCotizacion.sucursal,
            tipo_pago: infoCotizacion.tipo_pago,
            vigencia: infoCotizacion.vigencia,
            usuario: 0,
            detalle: JSON.stringify(infoCotizacion.detalle)
        }
        request
            .post(`Cotizaciones/AgregarCotizacion`, post)
            .then(async (result) => {
                setLoader({ ...loader, mostrar: false });
                // onClose();
                await Swal.fire({
                    title: "MODELOS",
                    text: "Registro guardado con éxito",
                    icon: "success",
                    customClass: {
                        container: "mi-superpoop",
                    },
                });
                history.push("/Ventas/Cotizaciones");
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                console.log(error)
                Swal.fire("MODELOS", JSON.stringify(error), "error");
            });
    };

    // console.log(infoCotizacion)
    return (
        <PlantillaScreen
            titulo={`REALIZAR COTIZACION`}
            className={"nueva-cotizacion-main-screen"}
            className_main={1}
        >
            <div className="nueva-cotizacion-actions">
                <div
                    className="nueva-cotizacion-actions-regresar"
                    onClick={() => history.goBack()}
                >
                    <ArrowBackIcon /> Regresar
                </div>
            </div>
            {asesores && clientes && modelos && (
                <>
                    <div className="nueva-cotizacion">
                        <LoaderScreen loader={loader} />
                        <div className="nueva-cotizacion-container">
                            <div className="nueva-cotizacion-form">
                                <div className="nueva-cotizacion-header">
                                    <div className="nueva-cotizacion-header-title">
                                        <FormatListNumberedIcon /> Informacion General
                                    </div>
                                </div>
                                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'nowrap', alignItems: 'center' }}>
                                    <Autocomplete
                                        size="small"
                                        id="dash-razonsocial"
                                        freeSolo
                                        options={clientes}
                                        sx={{
                                            mt: 1,
                                            width: rol === "Asesor" ? '35%' : '24%'
                                        }}
                                        getOptionLabel={(option) =>
                                            typeof option === 'string' ? option : option.razon_social || ""
                                        }
                                        value={
                                            // Si el idCliente existe, usa ese cliente
                                            clientes.find(c => c.idCliente === infoCotizacion.idCliente)
                                            // Si no, muestra el texto libre que se escribió
                                            || (infoCotizacion.razon_social ? infoCotizacion.razon_social : null)
                                        }
                                        onChange={(_, newValue) => {
                                            if (typeof newValue === 'string') {
                                                // Texto libre no está en la lista
                                                setInfoCotizacion({
                                                    ...infoCotizacion,
                                                    razon_social: newValue,
                                                    idCliente: 0
                                                });
                                            } else if (newValue && newValue.idCliente) {
                                                // Cliente seleccionado de la lista
                                                setInfoCotizacion({
                                                    ...infoCotizacion,
                                                    razon_social: newValue.razon_social,
                                                    idCliente: newValue.idCliente
                                                });
                                            } else {
                                                // Campo limpio
                                                setInfoCotizacion({
                                                    ...infoCotizacion,
                                                    razon_social: "",
                                                    idCliente: 0
                                                });
                                            }
                                        }}
                                        onInputChange={(_, inputValue, reason) => {
                                            if (reason === 'input') {
                                                setInfoCotizacion({
                                                    ...infoCotizacion,
                                                    razon_social: inputValue,
                                                    idCliente: 0
                                                });
                                            }
                                        }}
                                        renderOption={(props, option) => (
                                            <li {...props} key={option.idCliente}>
                                                {option.idCliente} - {option.razon_social}
                                            </li>
                                        )}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Cliente" />
                                        )}
                                    />

                                    {rol === "No_Asesor" && (
                                        <Autocomplete
                                            size="small"
                                            id="dash-asesor"
                                            // fullWidth
                                            options={asesores}
                                            sx={{
                                                mt: 1,
                                                width: rol === "Asesor" ? '0%' : '24%'
                                            }}
                                            getOptionLabel={(option) => option.vendedor || ""}
                                            value={asesores.find(c => c.idvendedor === infoCotizacion.idasesor) || null}
                                            onChange={(_, newValue) => {
                                                setInfoCotizacion({
                                                    ...infoCotizacion,
                                                    idasesor: newValue ? newValue.idvendedor : null
                                                });
                                            }}
                                            renderOption={(props, option) => (
                                                <li {...props} key={option.idvendedor}>
                                                    {option.idvendedor} - {option.vendedor}
                                                </li>
                                            )}
                                            renderInput={(params) => (
                                                <TextField {...params} label="Asesor de Venta" />
                                            )}
                                        />
                                    )}

                                    <FormControl size="small" disabled={modelosTabla?.length > 0} sx={{ mt: 1, width: rol === "Asesor" ? '31%' : '24%' }}>
                                        <InputLabel id="esquema-label">Esquema de pago</InputLabel>
                                        <Select
                                            labelId="esquema-label"
                                            id="select-esquema"
                                            value={esquemaSeleccionado ?? ""} // Usa "" como fallback para evitar warnings
                                            label="Esquema"
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setEsquemaSeleccionado(value);
                                                const esquemaObj = esquema.find((es) => es.idpromocion === Number(value));

                                                // Determinar nueva vigencia
                                                const nuevaVigencia = esquemaObj && esquemaObj.vigencia
                                                    ? formatoFechaParaInput(esquemaObj.vigencia)
                                                    : getUltimoDiaMes();

                                                // Determinar tipo_pago: 'CO' si incluye 'contado' o idpromocion === 0, si no 'CR'
                                                const nuevoTipoPago =
                                                    esquemaObj && (
                                                        (esquemaObj.descripcion_promocion || '').toLowerCase().includes('contado') ||
                                                        value === 0
                                                    )
                                                        ? 'CO'
                                                        : 'CR';

                                                setInfoCotizacion((prev) => ({
                                                    ...prev,
                                                    vigencia: nuevaVigencia,
                                                    tipo_pago: nuevoTipoPago
                                                }));
                                            }}
                                            sx={{
                                                height: '34px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                '& .MuiSelect-select': {
                                                    paddingY: '8px',
                                                }
                                            }}
                                        >
                                            <MenuItem key="0" value={0}>Sin esquema</MenuItem>
                                            {Array.isArray(esquema) && esquema.map((es) => (
                                                <MenuItem key={es.idpromocion} value={es.idpromocion}>
                                                    {es.descripcion_promocion}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <TextField
                                        // fullWidth
                                        size="small"
                                        variant="outlined"
                                        sx={{
                                            mt: 1,
                                            width: rol === "Asesor" ? '31%' : '24%'
                                        }}
                                        type="date"
                                        label="Vigencia"
                                        InputLabelProps={{ shrink: true }}
                                        onChange={({ target }) => {
                                            setInfoCotizacion((prev) => ({ ...prev, vigencia: target.value }));
                                        }}
                                        value={infoCotizacion.vigencia}
                                        disabled={Number(esquemaSeleccionado) > 0}
                                    />
                                    <FormControl size="small" sx={{ mt: 1, width: rol === "Asesor" ? '31%' : '24%' }}>
                                        <InputLabel id="moneda-label">Moneda</InputLabel>
                                        <Select
                                            labelId="moneda-label"
                                            id="select-moneda"
                                            value={moneda}
                                            label="Moneda"
                                            onChange={(e) => handleChangeMoneda(e.target.value)}
                                            sx={{
                                                height: '34px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                '& .MuiSelect-select': {
                                                    paddingY: '8px',
                                                }
                                            }}
                                        >
                                            <MenuItem key={'MXN'} value={'MXN'}>Pesos mexicanos</MenuItem>
                                            <MenuItem key={'USD'} value={'USD'}>Dólares</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Box>
                            </div>


                            <div className="tabla-modelos-section">
                                <div className="nueva-cotizacion-header-tabla">
                                    <div className="nueva-cotizacion-header-title">
                                        <FormatListNumberedIcon /> Modelos Seleccionados
                                    </div>
                                    <div
                                        className="nueva-cotizacion-actions-agregar"
                                        onClick={handleOpenModal}
                                    >
                                        <Add /> Agregar Modelo
                                    </div>
                                </div>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Modelo</th>
                                            <th><div>Descripcion</div></th>
                                            <th><div>Esquema de pago</div></th>
                                            {/* <th><div>Precio normal</div></th> */}
                                            <th><div>Precio</div></th>
                                            <th><div>Descuento</div></th>
                                            <th><div>Precio Final</div></th>
                                            <th style={{ color: "transparent" }}><div>.</div></th>
                                        </tr>
                                    </thead>
                                    {modelosTabla && (
                                        <>
                                            <tbody>
                                                {modelosTabla.map((mo, index) => (
                                                    <tr key={index}>
                                                        <td className="celda-modelo">{mo.modelo}</td>
                                                        {/* <td className="celda-descripcion">{capitalizePalabras(mo.mdl_descripcion)}</td> */}
                                                        <td className="celda-caracteristicas">{mo.mdl_descripcion}</td>
                                                        <td className="celda-esquema">{mo.esquema ?? 'Sin esquema de pago'}</td>
                                                        {/* <td className="celda-importe">{FormatMoney(mo.precio_lista)}</td> */}
                                                        <td className="celda-importe">{FormatMoney(mo.precio_promocion ?? mo.precio_lista)}</td>
                                                        <td className="celda-importe">{FormatMoney(mo.descuento)}</td>
                                                        <td className="celda-importe">{FormatMoney((mo.precio_promocion ?? mo.precio_lista) - mo.descuento)}</td>
                                                        {/* <td className="ta-center celda-moneda">{mo.moneda}</td> */}
                                                        <td className="celda-eliminar">
                                                            <div className="modelos-acciones-listado">
                                                                <div
                                                                    className="boton-editar-modelo"
                                                                    onClick={() => handleOpenModalEditar(index)}
                                                                >
                                                                    <EditIcon />
                                                                </div>
                                                                <div
                                                                    className="boton-eliminar-modelo"
                                                                    onClick={() => handleEliminarModelo(index)}
                                                                >
                                                                    <DeleteIcon />
                                                                </div>

                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </>
                                    )}
                                </table>
                            </div>
                            <div className="buttons">
                                <div
                                    className="nueva-cotizacion-actions-guardar"
                                    onClick={() => guardarCotizacion()}
                                >
                                    <Save /> Guardar
                                </div>
                            </div>
                        </div>
                        <SelectModelosModal
                            open={openModal}
                            onClose={handleCloseModal}
                            modelos={esquemaSeleccionado != 0 ? modelosEsquema : modelos}
                            onAñadir={handleAgregarModelo}
                            moneda={moneda}
                            esquemaSeleccionado={esquemaSeleccionado}
                        />
                        <EditarModelosModal
                            open={openModalEditar}
                            onClose={handleCloseModalEditar}
                            modelos={modelos}
                            onModificar={handleModificarModelo}
                            condiciones={selectedDetalle}
                        />
                    </div>
                </>
            )
            }
        </PlantillaScreen >
    );
};
